<template>
  <div class="bar-bg">
    <div class="bar"
         v-bind:class="[name, zeroClass]"
         v-bind:style="barWidth"><slot></slot></div>
  </div>
</template>

<script>

  export default {
    components: {
    },
    data() {
      return {
          zeroClass: null
      };
    },
    props: {
      selectedVal: Number,
      min: Number,
      max: Number,
      name: String
    },
    computed: {
      barWidth() {
        this.zeroClass = this.selectedVal ? null : 'zero';
        let width = this.selectedVal ? this.findPercentage(this.min, this.max, this.selectedVal) : 0;
        return {
          width: width + '%'
        };
      }
    },
    methods: {
      findPercentage(min, max, input) {
        return ((input - min) * 100) / (max - min);
      }
    }
  };
</script>

<style scoped lang="scss">
  .bar-bg {
    margin: 0;
    overflow: hidden;
    padding-left: 12px;

    & > .bar {
      background-color: whitesmoke;
      margin: .4em 0 .4em 20px;
      padding-left: 5px;
      color: #6c757d;
      font-size: .8em;
      font-weight: bold;
      white-space: nowrap;
      border-bottom: 2px solid #6c757d;

      &.zero {
        color: #6c757d;
        padding: 0;
        font-weight: bold;

        &:before {
          padding-left: 10px;
        }
      }

      &:before {
        width: 25px;
        display: inline-block;
        margin-left: -35px;
        margin-right: 10px;
        color: #6c757d;
        font-weight: bold;
        text-align: right;
      }
      &.og:before { content: 'OG '; }
      &.fg:before { content: 'FG '; }
      &.ibu:before { content: 'IBU '; }
      &.abv:before { content: 'ABV '; }
      &.ebc:before { content: 'EBC '; }
    }
  }

</style>
